export default {
    ASSET_TYPE: [
        [88, 'Equipment'],
        [89, 'HVAC'],
        [90, 'Facility'],
        [91, 'Vehicle'],
        [92, 'Workstation'],
        [93, 'Server'],
        [94, 'Voip'],
        [95, 'UPS'],
        [96, 'Tooling'],
        [97, 'Mobile Device'],
        [232, 'Tablet'],
        [233, 'Phone'],
        [234, 'Laptop'],
        [335, 'Production Machine'],
        [421, 'Printer'],
        [422, 'Wireless'],
        [423, 'Monitor']
    ]
}